angular.module('NumbersEditor')
    .factory('PublishGameFactory', [
        '$http', function($http) {

            var urlBase = '/api/Game';
            var publishGameFactory = {};

            publishGameFactory.PublishGame = function(id) {
                return $http.post(urlBase + '/' + id + '/publish');
            };

            publishGameFactory.HasLastWeekGameCompleted = function(id) {
                return $http.get(urlBase + '/' + id + '/haslastweekgamecompleted');
            };

           

            return publishGameFactory;
        }
    ]);